import { useState, useEffect } from 'react';
import useSWR from 'swr';
import fetcher from '@utils/fetcher';

const imageDomain = 'http://glombi.accordde.com/video';

const useVideoData = (
    supportedLanguages,
    versionNumber,
) => {
    const { data: videoData, error } = useSWR(
        `${imageDomain}/SoccerList-${supportedLanguages[0]}.json?v=${versionNumber}`,
        fetcher,
        { revalidateOnFocus: false },
    );

    const isLoading = !videoData && !error;

    return { videoData, isLoading };
};

export default useVideoData;
